import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { useSensitiveInfoInputContext } from '../Context';
import UnlockedInput from './UnlockedInput';
import LockedInput from './LockedInput';

const styles = () => ({
  root: {},
  adornment: {},
});

const SensitiveInfoInputContent = ({
  className,
  classes,
  LockedInputComponent,
  UnlockedInputComponent,
  LockedInputProps,
  UnlockedInputProps,
}) => {
  const { isLocked } = useSensitiveInfoInputContext();
  if (isLocked) {
    return (
      <LockedInput
        className={classNames(className, classes.root)}
        {...LockedInputProps}
        InputComponent={LockedInputComponent}
      />
    );
  }

  return (
    <UnlockedInput
      className={classNames(className, classes.root)}
      {...UnlockedInputProps}
      InputComponent={UnlockedInputComponent}
    />
  );
};

SensitiveInfoInputContent.defaultProps = {
  className: '',
};

SensitiveInfoInputContent.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  LockedInputComponent: PropTypes.object.isRequired,
  UnlockedInputComponent: PropTypes.object.isRequired,
  LockedInputProps: PropTypes.object.isRequired,
  UnlockedInputProps: PropTypes.object.isRequired,
};

export default withStyles(styles)(SensitiveInfoInputContent);
